import React, { Fragment, useState } from 'react';
import Qs from 'qs';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import _capitalize from 'lodash/capitalize';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';
import { Button, Tooltip } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styled from 'styled-components';

import * as ENDPOINT from 'config/endpoint';
import * as FILTER from 'pages/Hotels/HotelsList/helpers/constants';
import { IconInfo } from 'assets/icons';
import { getRubles, turnOffEvent } from 'utils/helpers';
import { appStoreMakeRequest } from 'reactStore/slices/appStoreSlice';
import MText from 'components/MaterialUI/MText';
import CancelPenalties from 'pages/Hotels/components/CancelPenalties';
import { RoomInfoWrapper } from './HotelRateTyles.styles';
import { RegularWrapper } from 'components/common';

const HotelRateTypes = (props) => {
  const { types, storeName, isLoading } = props;

  const { id } = useParams();
  const { push } = useHistory();
  const { search } = useLocation();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showMore, setShowMore] = useState(false);

  const handleMakeOrder = (room) => async (e) => {
    turnOffEvent(e);
    // prettier-ignore
    const { query: {travellers, ...query} } = Qs.parse(search, { ignoreQueryPrefix: true });
    const contract_id = localStorage.getItem('activeContractId').split('"').join('');
    const data = {
      data: {
        contract_id,
        hotel: {
          order_items: [
            {
              segment: {
                ...query,
                hotel_id: id,
                guests: travellers,
                rate_match_hash: room.match_hash,
              },
            },
          ],
        },
      },
    };

    const mapper = (resp, old) => {
      const { data } = resp.data;
      push(`/hotels/${id}/book?order_id=${data.id}`);
      return old;
    };

    dispatch(appStoreMakeRequest({ storeName, dataSource: ENDPOINT.ORDERS, method: 'POST', data, mapper }));
  };

  const getTooltip = (key) => {
    if (FILTER.NO_MEAL_TYPES.includes(key)) return t('Hotels.NoMealTooltip');
    if (FILTER.ALL_INCLUSIVE_TYPES.includes(key)) return t('Hotels.AllInclusive');
    if (FILTER.HALF_BOARD_TYPES.includes(key)) return t('Hotels.HalfBoardTooltip');
    if (FILTER.FULL_BOARD_TYPES.includes(key)) return t('Hotels.FullBoardTooltip');
    if (FILTER.BREAKFAST_TYPES.includes(key)) return t('Hotels.HasBreakfastTooltip');
    return '';
  };

  return (
    <Fragment>
      {(showMore ? types : types.slice(0, 2)).map((room, index) => (
        <RoomInfoWrapper key={room?.book_hash || index}>
          <MText {...{ isLoading }} width={200} variant="body2" weight="bold">
            {_capitalize(room?.['room_data_trans']?.['bedding_type'] || 'На усморение отеля')}
          </MText>

          <RegularWrapper>
            <MText
              {...{ isLoading }}
              width={200}
              variant="body2"
              sx={{ padding: '0 8px 0 0' }}
              children={_capitalize(t(`Hotels.${room?.meal || index}`))}
            />
            {!isLoading && (
              <Tooltip arrow placement="top" title={getTooltip(room?.meal || index)}>
                <div children={<IconInfo sx={{ height: 16, width: 16 }} />} />
              </Tooltip>
            )}
          </RegularWrapper>

          <RegularWrapper>
            <MText {...{ isLoading }} width={200} variant="body2" sx={{ padding: '0 8px 0 0' }}>
              {!!room['free_cancellation_before'] ? 'Возвратный' : 'Невозвратный'}
            </MText>
            {!isLoading && room['cancellation_penalties'] && (
              <Tooltip
                arrow
                placement="top"
                title={
                  <CancelPenalties
                    cancellationPenalties={room['cancellation_penalties']}
                    freeCancellationBefore={room['free_cancellation_before']}
                  />
                }
                children={<div children={<IconInfo sx={{ height: 16, width: 16 }} />} />}
              />
            )}
          </RegularWrapper>

          <MText {...{ isLoading }} width={70} weight="bold" variant="h3">
            {getRubles(room['amount_sell'])}
          </MText>

          <RegularWrapper justify={'flex-end'}>
            <Button
              size="small"
              color="warning"
              variant="contained"
              disabled={isLoading}
              onClick={handleMakeOrder(room)}
              children={t('Actions.MakeOrder')}
            />
          </RegularWrapper>
        </RoomInfoWrapper>
      ))}

      {!isLoading && types.length > 2 && (
        <RegularWrapper padding={'12px 0 0'}>
          <Button
            fullWidth
            variant="text"
            sx={{ color: 'blue4.main', backgroundColor: 'blue5.main' }}
            endIcon={showMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            onClick={() => setShowMore((old) => !old)}
            children={
              showMore
                ? t('Actions.Hide')
                : `${t('Actions.ShowMoreRooms')} ${t('Plurals.Rates', { count: types.length - 2 })}`
            }
          />
        </RegularWrapper>
      )}
    </Fragment>
  );
};

HotelRateTypes.propTypes = {
  rate: PropTypes.array,
  types: PropTypes.array,
  isLoading: PropTypes.bool,
  storeName: PropTypes.string,
};

HotelRateTypes.defaultProps = {
  types: [],
};

export default styled(HotelRateTypes)``;
